import { Button } from "primereact/button";
import {
  type ReferenceDatumInput,
  updateReferenceDatum,
} from "../../../../api-requests/reference-data";
import EditIcon from "../../../../components/icons/EditIcon";
import type { SchemaField } from "../../../../helpers/format-databases";
import type { ReferenceDatum } from "../../../../helpers/format-reference-data";
import { syncOpenModalDialog } from "../../../shared/global-tools/dialog-system";
import makeReferenceDatumFormDialog, {
  type ReferenceDatumFormDialogParameter,
} from "./ReferenceDatumFormDialog/ReferenceDatumFormDialog";

export default function EditAction({
  referenceId,
  referenceDatum,
  schema,
}: { referenceId: number; referenceDatum: ReferenceDatum; schema: SchemaField[] }) {
  const handleEdit = async (input: ReferenceDatumInput | FormData) => {
    await updateReferenceDatum({
      referenceId: referenceId,
      datumId: referenceDatum.id,
      body: input,
    });
  };

  return (
    <Button
      className="p-outlined-primary IconOnlyBtn"
      icon={<EditIcon />}
      rounded
      text
      onClick={() =>
        syncOpenModalDialog<ReferenceDatumFormDialogParameter>(makeReferenceDatumFormDialog, {
          save: handleEdit,
          referenceDatum,
          referenceId,
          schema,
          header: "Editer la donnée",
          successMessage: "Donnée editée",
          errorMessage: "Echec mise à jour donnée",
        })
      }
    />
  );
}
